// FullCanvas — wraps the editorial screens so they break out of the legacy
// `#root` max-width / padding cascade and fill the iOS viewport edge-to-edge.
//
// `position: fixed; inset: 0` escapes the constrained `#root` container
// (still in use by the v2/v0 screens). Two viewport heights: `100vh` as
// the safe fallback for older iOS, then `100dvh` via @supports for modern
// Safari (dynamic viewport — collapses with the address bar).
//
// Safe-area insets push children below the notch and above the home
// indicator. Inner screens still own their own `pt-14` etc., but the
// `env(safe-area-inset-*)` padding ensures nothing renders behind the
// notch or home indicator regardless of inner padding.
import React from 'react';

export function FullCanvas({ children }: { children: React.ReactNode }) {
  return (
    <div className="ob-fullcanvas">
      {children}
    </div>
  );
}
